import Swal from 'sweetalert2';

window.Swal = Swal;

function isSameOriginRequest(url) {
  try {
    return new URL(url, window.location.href).origin === window.location.origin;
  } catch {
    return true;
  }
}

$.ajaxSetup({
  beforeSend(xhr, settings) {
    const requestUrl = settings.url || '';
    if (!isSameOriginRequest(requestUrl)) {
      return;
    }
    const token = $('meta[name="csrf-token"]').attr('content');
    if (token) {
      xhr.setRequestHeader('X-CSRF-TOKEN', token);
    }
  },
});

import './modules/bills';
import './modules/excel-import';
import './modules/bills-modal';
import './plugins/datepicker';


